import axios, { AxiosError } from "axios";
import ConsultationAxios from "../config/consultation.config";

/**
 * ✅ API to Verify Video Call Sessio
 * @param {string} userId - The ID of the user or consultant
 * @param {string} consultationId - The consultation session ID
 * @param {"USER" | "CONSULTANT"} role - The role of the user
 * @returns {Promise<VerifyVideoCallResponse>} - The API response
 */
export const verifyVideoCallSessionApi = async (
  userId: string,
  consultationId: string,
  role: "USER" | "CONSULTANT"
): Promise<VerifyVideoCallResponse> => {
  try {
    const response = await ConsultationAxios.get(`/verify-video-call/${userId}`, {
      params: {
        cid: consultationId,
        role: role,
      },
    });

    return response.data as VerifyVideoCallResponse;
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      const axiosError = err.response?.data as AxiosError;
      throw new Error(axiosError.message);
    }

    throw new Error("Failed to verify video call session. Please try again later!");
  }
};

/**
 * ✅ Type Definitions for API Response
 */
export interface VerifyVideoCallResponse {
  role: "USER" | "CONSULTANT";
  sessionLength: number;
  id: string;
  firstName: string;
  time: string;
}
